import InboxHeaderFilterMenuItem from "./InboxHeaderFilterMenuItem";

import { HandleTabToggleVisibility } from "..";
import { InboxActiveTab } from "../../../types/inbox/enum";
import { FilterIcon } from "../../atom/icons/FilterIcon";
import { InboxAccordion } from "../../../types/inbox/type";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../atom/Dropdown/Dropdown";
import { useState } from "react";
import clsx from "clsx";

/** Inbox area header 우측 필터 버튼 */
interface InboxHeaderFilterButtonProps {
  activeTab: InboxActiveTab;
  onToggleVisibility: HandleTabToggleVisibility;
  toggleVisibility: InboxAccordion;
}
const InboxHeaderFilterButton = ({
  activeTab,
  toggleVisibility,
  onToggleVisibility,
}: InboxHeaderFilterButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenChange = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };
  return (
    <DropdownMenu
      open={isOpen}
      onOpenChange={handleOpenChange}
    >
      <DropdownMenuTrigger asChild>
        <button
          className={clsx(
            "flex h-7 w-7 cursor-pointer items-center justify-center rounded-[5px] bg-transparent text-[#CACDCE] hover:text-white focus:outline-none",
            {
              "bg-w-8-hover": isOpen,
              "hover:bg-w-8-hover active:bg-w-8-hover": !isOpen,
            }
          )}
          aria-label="inbox-filter"
        >
          <FilterIcon />
        </button>
      </DropdownMenuTrigger>
      {/* 버튼 클릭 시 뜨는 필터 메뉴 목록 */}
      <DropdownMenuContent
        width="170px"
        sideOffset={5}
        align="end"
        className="m-0 w-[170px] overflow-hidden rounded-[6px] border border-white/20 bg-[#2F3131] p-0 text-white"
      >
        <InboxHeaderFilterMenuItem
          title="overdue"
          activeTab={activeTab}
          onToggleVisibility={onToggleVisibility}
          toggleVisibility={toggleVisibility}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default InboxHeaderFilterButton;
